import styled from "styled-components";

export const Container = styled.div`
  -webkit-touch-callout: none; /* iPhone OS, Safari */
  -webkit-user-select: none; /* Chrome, Safari 3 */
  -khtml-user-select: none; /* Safari 2 */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none;
  width: ${(props) => (props.isModal ? "100%" : "280px")};
  max-width: 100%;
  background-color: ${(props) => props.theme.colors.white};
  padding: 20px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.neutral100};
  box-shadow: var(--cards);

  h1 {
    margin-bottom: 12px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.neutral900};
`;

export const ClearLink = styled.button`
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-family: var(--link-font-family);
  font-weight: var(--link-font-weight);
  font-size: var(--link-font-size);
  color: ${(props) => props.theme.colors.primary};

  &::before {
    content: "\\00d7";
    margin-right: 4px;
  }
`;

export const Header = styled.h3`
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
  color: ${(props) => props.theme.colors.neutral400};
`;

export const ContainerCheckFilter = styled.div`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary30 : "transparent"};

  :hover {
    background-color: ${(props) =>
      props.selected
        ? props.theme.colors.primary40
        : props.theme.colors.neutral50};
  }

  label {
    margin-left: 8px;
    font-size: 13px;
    cursor: pointer;
    color: ${(props) =>
      props.selected
        ? props.theme.colors.primary
        : props.theme.colors.neutral900};
    font-weight: ${(props) => (props.selected ? 700 : 400)};
  }

  input {
    cursor: pointer;
  }
`;

export const ContentFilter = styled.div`
  margin-bottom: 20px;

  .items {
    max-height: 200px;
    overflow-y: auto;
  }

  .div-custom-scroll::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .div-custom-scroll::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  .div-custom-scroll::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.primary};
    border-radius: 4px;
  }
`;

export const ContainerButton = styled.div`
  border-radius: 16px 16px 0px 0px;
  border-top: 1px solid ${(props) => props.theme.colors.gray};
  padding-bottom: 24px;

  .buttonFilter {
    margin-top: 26px;
    margin-bottom: 24px;
  }
`;

export const ContainerInfoFilter = styled.div`
  padding: 0px ${(props) => (props.hasPadding ? 24 : 0)}px;
`;

export const ContainerFilters = styled.div``;

export const ContainerFiltersSelected = styled.div`
  margin-bottom: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;

  > span {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 12px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.neutral400};
  }

  ul {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  li {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: ${(props) => props.theme.colors.primary30};
    color: ${(props) => props.theme.colors.primary};
    border-radius: 999px;
    padding: 4px 10px;

    span {
      font-size: 13px;
    }

    button {
      background: none;
      border: 0;
      padding: 0;
      line-height: 1;
      cursor: pointer;
      color: ${(props) => props.theme.colors.primary};
    }
  }

  .cleanAll {
    align-self: flex-start;
    margin-top: 12px;
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
    font-family: var(--link-font-family);
    font-weight: var(--link-font-weight);
    font-size: var(--link-font-size);
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }
`;

export const ContainerCloseRound = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  .closeRound {
    margin-top: 40px;
    margin-right: 16px;
  }
`;

export const InputField = styled.input`
  height: 40px;
  background-color: ${(props) => props.theme.colors.neutral50};
  border: 1px solid
    ${(props) =>
      props.invalid
        ? props.theme.colors.warning
        : props.theme.colors.neutral100};
  font-size: 16px;
  border-radius: 12px;
  margin-bottom: 10px;
  padding-left: 12px;
  padding-right: 12px;
  width: 100%;

  input {
    width: 300px;
  }

  + label {
    font-size: 14px;
    color: ${(props) =>
      props.invalid
        ? props.theme.colors.warning
        : props.theme.colors.neutral900};
  }

  :focus {
    border: 1px solid
      ${(props) =>
        props.invalid
          ? props.theme.colors.warning
          : props.theme.colors.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  :focus + label {
    color: ${(props) =>
      props.invalid ? props.theme.colors.warning : props.theme.colors.primary};
  }
`;
